/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNews} from '../api'

 export const useQueryGetNews = createReactQueryHook('getNews', getNews)
